import { render, staticRenderFns } from "./indexEvaluacionShow.vue?vue&type=template&id=618bbe24&scoped=true"
import script from "./indexEvaluacionShow.vue?vue&type=script&lang=js"
export * from "./indexEvaluacionShow.vue?vue&type=script&lang=js"
import style0 from "./indexEvaluacionShow.vue?vue&type=style&index=0&id=618bbe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618bbe24",
  null
  
)

export default component.exports